
export const StringUtils = {

  capitalize: (str: string) => str.charAt(0).toUpperCase() + str.substring(1)

}
